import React from 'react';
import { FadeIn } from './FadeIn';
export function AriseMethod() {
  const pillars = [{
    letter: 'A',
    title: 'Awareness',
    desc: 'Vezi realitatea așa cum este, fără distorsiuni. Identifici unde ești cu adevărat, ce te blochează și ce nu mai e aliniat în viața ta. Înțelegi diferența dintre viața funcțională și viața autentică și de unde vine senzația că „ceva nu e în regulă".'
  }, {
    letter: 'R',
    title: 'Release',
    desc: 'Eliberezi blocajele emoționale și sistemice care te țin în aceleași tipare. Lucrezi cu emoții reprimate, răni vechi și reacții automate. Reduci încărcătura emoțională acumulată și înțelegi de unde vin reacțiile care nu te reprezintă.'
  }, {
    letter: 'I',
    title: 'Identity',
    desc: 'Reconstruiești cine ești dincolo de roluri și adaptări. Redescoperi valorile tale reale, nu cele impuse, și începi să te alegi pe tine. Treci de la „cine ar trebui să fiu" la „cine sunt eu cu adevărat".'
  }, {
    letter: 'S',
    title: 'System Alignment',
    desc: 'Reașezi relațiile și dinamica din viața ta: cuplu, familie, carieră. Înțelegi loialitățile invizibile și tiparele transgeneraționale care te influențează. Construiești relații mai sănătoase și conștiente, pornind de la locul tău real în sistem.'
  }, {
    letter: 'E',
    title: 'Embodiment',
    desc: 'Trăiești noua identitate în viața reală. Iei decizii aliniate cu cine ești, stabilești limite sănătoase și construiești o viață care te reprezintă. Nu mai înțelegi doar diferit. Începi să trăiești diferit.'
  }];
  return <section className="relative py-24 md:py-32 bg-forest overflow-hidden" data-id="element-262">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-263">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold/10 rounded-full blur-3xl" data-id="element-264"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-white/5 rounded-full blur-3xl" data-id="element-265"></div>

        {/* Large background text */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[18vw] font-serif font-bold text-ivory/[0.04] whitespace-nowrap select-none tracking-[0.2em]" data-id="element-266">
          A.R.I.S.E.
        </div>
      </div>

      <div className="max-w-[900px] mx-auto px-6 md:px-8 relative z-10" data-id="element-267">
        <div className="text-center mb-16" data-id="element-268">
          <FadeIn data-id="element-269">
            <span className="inline-block font-display text-xs font-semibold tracking-[0.3em] text-gold uppercase mb-4" data-id="element-270">
              METODA UNICĂ
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-ivory mb-6" data-id="element-271">
              Metoda A.R.I.S.E.
            </h2>
            <p className="text-lg md:text-[20px] text-ivory/80 font-sans leading-relaxed max-w-[750px] mx-auto" data-id="element-272">
              Procesul prin care îți realiniezi mintea, emoțiile și relațiile,
              ca să ieși din epuizare și blocaje și să ajungi la claritate,
              încredere și o viață care te reprezintă. Lucrăm simultan pe trei
              niveluri: minte, emoții și sistemul din care vii.
            </p>
          </FadeIn>
        </div>

        {/* Vertical stack of pillars */}
        <div className="space-y-5" data-id="element-273">
          {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-274">
              <div className="group bg-ivory border border-gold/20 rounded-2xl p-6 md:p-8 transition-all duration-500 hover:shadow-xl shadow-md" data-id="element-275">
                <div className="flex items-start gap-5 md:gap-7" data-id="element-276">
                  {/* Letter badge */}
                  <div className="shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center shadow-md shadow-black/20 group-hover:scale-105 transition-transform duration-500" data-id="element-277">
                    <span className="font-serif text-2xl md:text-3xl font-bold text-forest" data-id="element-278">
                      {pillar.letter}
                    </span>
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-279">
                    <h3 className="text-xl md:text-2xl font-serif font-medium text-forest mb-2" data-id="element-280">
                      {pillar.title}
                    </h3>
                    <p className="text-charcoal/80 text-[18px] md:text-[19px] leading-relaxed" data-id="element-281">
                      {pillar.desc}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}